module.exports = __webpack_public_path__ + "img/Hugo Contreras Aragón_Gerente de Producción.aafcc937.png";